module.exports = "/virtual-football-league/img/amblems/right/logos/GRANADA.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/GRANADA.png
// module id = 2200
// module chunks = 4